window.toastMixin = Swal.mixin({
  toast: false,
  icon: "success",
  title: "",
  animation: true,
  position: "center",
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: false,
  customClass: {
    container: "popup-promociones",
  },
});
 

$(document).on("click", ".template-search .reset__button", function (e) {
  e.preventDefault();
  document.location = "/collections/all";
  return false;
});

$(document).on("click", "#barra-busqueda-boton", function (e) {
  e.preventDefault();
  var boton = $(this);
  boton.addClass("active");
  setTimeout(function () {
    boton.removeClass("active");
  }, 350);
  var input = boton.parent().find("input").val().trim();
  if (input) {
    boton.parent().submit();
  }
  return false;
});

$(document).ready(function () {
  if (productoActual && productoActual.id == 10158698529073) {
    $('[for="template--22918306332977__main-1-1"]').click();
  }

  $(
    '[data-card-producto-handle="tune-up"],[data-card-producto-handle="programa-de-desparasitacion-lunar"], [data-card-producto-handle="programa-menu-keat"], [data-card-producto-handle="programa-reto-keat"], [data-card-producto-handle*="programa-kaldos"]'
  )
    .find("[data-modal]")
    .each(function (index, item) {
      let modal = $(item).attr("data-modal");
      $(modal).remove();
    });
  $(
    '[data-card-producto-handle="desintoxicacion-programa-tune-up-air-detox"], [data-card-producto-handle="reto-recupera-tu-salud"], [data-card-producto-handle="programa-reto-keat-4-semanas"], [data-card-producto-handle="programa-tune-up-springbreak"], [data-card-producto-handle="caldo-de-huesos-paquete"]'
  )
    .find("[data-modal]")
    .each(function (index, item) {
      let modal = $(item).attr("data-modal");
      $(modal).remove();
    });

  if ($("[name=product-id][value=9360531521841]").length) {
    var bundle3dias = 48385474855217;
    var bundle5dias = 48385474887985;
    var bundleDias = $(
      '[name="Selecciona el número de dias para tu programa"]:checked'
    ).val();
    $("#ProductSubmitButton-template--21531687387441__main").on(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        let formData = {
          items: [
            {
              id: bundleDias == "3 días" ? bundle3dias : bundle5dias,
              quantity: 1,
            },
          ],
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        return false;
      }
    );
  }
 

  if (productoActual && productoActual.price_max) {
    if (productoActual.price_max / 100 >= 6000) {
      $("#pago-meses").show();
    }
  }
  if (document.location.search.includes("tracking=kaldo")) {
    document.location =
      "https://cdn.shopify.com/s/files/1/0841/7299/6913/files/GUIA_PARA_USAR_TUS_KALDOS_KEAT_23-24.pdf?v=1699720202";
    return;
  }

  if (document.location.pathname === "/kaldo-keat/paquete-de-24-kaldos-keat") {
    document.location = "https://keat.mx/products/caldo-de-huesos-paquete";
  }

  if (document.location.pathname === "/kaldo-keat/paquete-de-16-kaldos-keat") {
    document.location = "https://keat.mx/products/caldo-de-huesos-paquete";
  }

  if (document.location.pathname === "/snacks") {
    document.location = "https://keat.mx/collections/all?filter.p.m.custom.categoria=Snacks";
  }

  if (document.location.pathname === "/snacks/paquete-keat-inicio") {
    document.location = "https://keat.mx/collections/productos-de-alimentacion";
  }

  if (
    document.location.pathname === "/kaldos" ||
    document.location.pathname === "/suscripciones"
  ) {
    document.location = "https://keat.mx/products/caldo-de-huesos-paquete";
  }

  if (document.location.pathname === "/metodo") {
    document.location = "https://keat.mx/pages/por-que-k-eat";
  }

  if (document.location.pathname === "/programas") {
    document.location = "https://keat.mx/collections/productos-de-alimentacion";
  }

  if (document.location.pathname === "/keat-start") {
    document.location = "https://keat.mx";
  }

  if (!$("#ProductDateBuilder").length) {
    if (
      $(
        '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-0"]'
      ).length
    ) {
      $(
        '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-0"]'
      ).append(
        '<p class="precio-por-paquete"><span>$165</span><span>/</span><span>pz.</span></p>'
      );
      $(
        '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-1"]'
      ).append(
        '<p class="precio-por-paquete"><span>$165</span><span>/</span><span>pz.</span></p>'
      );
      $(
        '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-2"]'
      ).append(
        '<p class="precio-por-paquete"><span>$160</span><span>/</span><span>pz.</span></p>'
      );
      $(
        '[for="template--21508447994161__301f7d81-8bb3-4809-89de-61830541f62f-1-3"]'
      ).append(
        '<p class="precio-por-paquete"><span>$157</span><span>/</span><span>pz.</span></p>'
      );
      window.productoDestacado = JSON.parse(
        $("variant-radios [type='application/json']").html()
      );
    }
    $("#fecha-inicio-campo").remove();
    $("#turno-entrega-campo").remove();
  } else {
    $("#combinacion").remove();
  }

  if (
    !$("#ProductDateBuilder").length &&
    !$("#ProductBuilderComponentKaldos").length
  ) {
    $("#fecha-inicio-campo").remove();
    $("#turno-entrega-campo").remove();
    $("#combinacion").remove();
  }
});

$(document).on("input", "#turno-entrega-producto-date-builder", function (e) {
  let valor = $(this).val() || "";
  let fechaInicio = $("#fecha-inicio-campo").val();
  $("#turno-entrega-campo").val(valor);
  if (valor.length && fechaInicio.length) {
    $(".product-form__submit").removeAttr("disabled");
  } else {
    $(".product-form__submit").attr("disabled", true);
  }
});

$(document).on("input", "#fecha-inicio", function (e) {
  let valor = $(this).val() || "";
  let turnoEntrega = $("#turno-entrega-campo").val();
  $("#fecha-inicio-campo").val(valor);
  if (productoActual.id == 10121389670705 && valor.length) {
    $(".product-form__submit").removeAttr("disabled");
  } else {
    if (valor.length && turnoEntrega.length) {
      $(".product-form__submit").removeAttr("disabled");
    } else {
      $(".product-form__submit").attr("disabled", true);
    }
  }
});

$(document).on(
  "input",
  '[name="Selecciona el número de semanas"]',
  function (e) {
    var dias = $(this).val().trim();
    setTimeout(function () {
      if (window.fPicker && window.fPicker.clear) {
        window.fPicker.clear();
        let fechasDisabled = [];
        $("#fecha-inicio").val("").trigger("input");
        $(".product-form__submit").attr("disabled", true);
        window.fPicker.set("enable", getLunesMiercolesCalendario());
      } else {
        $(".product-form__submit")
          .removeClass("semanas")
          .removeClass("semana")
          .removeClass("semanas-5")
          .removeClass("semanas-4")
          .removeClass("semanas-3")
          .removeClass("semanas-2")
          .removeClass("semanas-1");
        $(".product-form__submit").addClass(
          "semanas-" + dias + "-" + productoActual.id
        );
        $("#fecha-inicio").val("").trigger("input");
        $(".product-form__submit").attr("disabled", true);
      }
    }, 450);
  }
);

$(document).on("input", '[name="Selecciona número de estudios"]', function (e) {
  setTimeout(function () {
    if (!$("#fecha-inicio").val()) {
      $(".product-form__submit").attr("disabled", true);
    }
  }, 450);
});

$(document).on(
  "input",
  '[name="Desintoxicación  Programa Tune Up (Selecciona el número de dias para tu programa)"]',
  function (e) {
    setTimeout(function () {
      $("#fecha-inicio").val("").trigger("input");
      $(".product-form__submit").attr("disabled", true);
    }, 450);
  }
);

$(document).on(
  "input",
  '[name="Selecciona el número de dias para tu programa"]',
  function (e) {
    var dias = $(this).val().trim();
    $("#fecha-inicio").val('')
    $("#turno-entrega-producto-date-builder").val('')
     $(".product-form__submit").attr("disabled", true);
    if (dias == "5 días") {
      $("#fecha-inicio option:not([data-dia='Monday'])").hide()
    }else{
      $("#fecha-inicio option:not([data-dia='Monday'])").show()
    }
  }) 

async function addToCartEspecial(
  producto,
  variante,
  href,
  callback,
  cantidad = 1,
  turno = ""
) {
  fetch("https://keat.mx/cart/add", {
    headers: {
      accept: "application/javascript",
      "content-type":
        "multipart/form-data; boundary=----WebKitFormBoundaryBBO7G82hdbybXCvE",
    },
    body: `------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"properties[Turno de entrega]\"\r\n\r\n${turno}\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"form_type\"\r\n\r\nproduct\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name="quantity"\r\n\r\n${cantidad}\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"utf8\"\r\n\r\n✓\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"id\"\r\n\r\n${variante}\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"product-id\"\r\n\r\n${producto}\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"section-id\"\r\n\r\ntemplate--21664729170225__main\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"sections\"\r\n\r\ncart-notification-product,cart-notification-button,cart-icon-bubble\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE\r\nContent-Disposition: form-data; name=\"sections_url\"\r\n\r\n${href}\r\n------WebKitFormBoundaryBBO7G82hdbybXCvE--\r\n`,
    method: "POST",
    mode: "cors",
    credentials: "include",
  })
    .then((e) => e.json())
    .then((res) => {
      if (callback) {
        callback(res);
      }
    });
}

window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

$(document).ready(function () {
  if ($("#programas-kaldos-variantes").length) {
    $("variant-radios").hide();
    $(".product-form__submit").attr("disabled", true);
    var html = "<div class='keat-row'>";
    productoActual.variants.forEach((variant, index) => {
      html += `<div class="keat-col-12"><label class="form-control">
      <input type="checkbox" data-index="${index}" class="variants variantes-checkbox" value="${
        variant.id
      }"> Semana ${
        index + 1
      } <span style="font-weight:normal !important;display:contents;font-size:14px;">(14 pz.)</span></label>
      </div>`;
    });
    html += "</div>";
    $("#programas-kaldos-variantes").html(html);
    $(".product-form__submit").off("click");
    $(".product-form__submit").on("click", function (e) {
      e.preventDefault();
      const el = $(this);
      el.addClass("loading").addClass("disabled");
      el.find(".loading-overlay__spinner").removeClass("hidden");
      var checkboxesTotales = document.querySelectorAll(
        "#programas-kaldos-variantes input[type=checkbox]"
      );
      var checkboxes = document.querySelectorAll(
        "#programas-kaldos-variantes input[type=checkbox]:checked"
      );
      let items = [];

      for (var i = 0; i < checkboxes.length; i++) {
        let variantId = checkboxes[i].value;
        items.push({
          id: variantId,
          quantity: 1,
        });
      }

      let semanas = $(
        "#programas-kaldos-variantes input[type=checkbox]"
      ).length;
      let semanasSeleccionadas = checkboxes.length;

      let ultimo = items.shift();

      if (items.length == 0) {
        addToCartEspecial(
          productoActual.id,
          ultimo.id,
          $("product-info[data-url]").attr("data-url"),
          function (res) {
            let c = new CartNotification();
            c.renderContents(res);
            el.removeClass("loading").removeClass("disabled");
            el.find(".loading-overlay__spinner").addClass("hidden");
          }
        );
      } else {
        let formData = { items };
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((r) => r.json())
          .then((res) => {
            addToCartEspecial(
              productoActual.id,
              ultimo.id,
              $("product-info[data-url]").attr("data-url"),
              function (res) {
                let c = new CartNotification();
                c.renderContents(res);
                el.removeClass("loading").removeClass("disabled");
                el.find(".loading-overlay__spinner").addClass("hidden");
              }
            );
          });
      }

      return false;
    });
  }
});

function formatearPrecio(centavos) { 
  const cantidad = Number(centavos) / 100;

  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(cantidad);
}

$(document).on("change", ".variantes-checkbox", function () {
  var precio=productoActual.price/100
  var el = $(this);
  if (el.is(":checked") && Number(el.attr("data-index")) == 0) {
    $(".variantes-checkbox[disabled]").removeAttr("disabled");
  }
  if ($(".variantes-checkbox:checked").length >= 1) {
    var seleccionados = $(".variantes-checkbox:checked").length;
    var precio =formatearPrecio(seleccionados*precio*100)

    $(".product-form__submit").removeAttr("disabled");
    $("[bss-po-product-price]").html(precio);
    $("#programas-kaldos-variantes-info span").text(seleccionados * 14);
    $("#programas-kaldos-variantes-info").show();
  } else {
    $("#programas-kaldos-variantes-info").hide();
    $("[bss-po-product-price]").html(formatearPrecio(productoActual.price));
    $(".product-form__submit").attr("disabled", true);
  }
});

function setRibbonEspeciales() {
  const productosEspeciales = JSON.parse(localStorage.productosLanding);
  for (const producto of productosEspeciales) {
    let selector = `[data-card-producto-handle="${producto.handle}"] .ribbon`;
    $(`${selector} span`).text("Collective 2x1");
    $(`${selector}`).show();

    if (productoActual && Number(productoActual.id) == Number(producto.id)) {
      selector = ".ribbon:not(.ribbon-mobile)";
      if (window.mobileCheck()) {
        selector = ".ribbon-mobile";
      }
      $(`${selector} span`).text("Collective 2x1");
      $(`${selector}`).show();
      $("product-form form").append(
        '<input type="hidden" name="quantity" value="2">'
      );
    }
  }
}

$(document).ready(function () {
  localStorage.removeItem("trackingEspecial");

  if (!window.mobileCheck()) {
    $(".product__media-wrapper").append($(".complementary-products"));
  }

  setTimeout(function () {
    if ($(".complementary-products").length) {
      $(".complementary-products .icon-accordion").parent().click();
    }
  }, 750);
});

 
  

$(document).on(
  "click",
  `product-info[data-url="/products/programa-de-desparasitacion-lunar"] .product-form__submit`,
  function (e) {
    e.preventDefault();
    const el = $(this);
    let cantidad = Number($(".quantity__input").val());
    el.addClass("loading").addClass("disabled");
    el.find(".loading-overlay__spinner").removeClass("hidden");
    let fechaInicio = $("#fecha-inicio-campo").val();
    let turnoEntrega = $("#turno-entrega-campo").val();
    fetch("https://keat.mx/cart/add", {
      headers: {
        accept: "application/javascript",
        "accept-language": "en,es;q=0.9,es-ES;q=0.8,pt;q=0.7",
        "content-type":
          "multipart/form-data; boundary=----WebKitFormBoundarylOLRDXJDqKLhR1Bn",
        priority: "u=1, i",
        "sec-ch-ua":
          '"Chromium";v="130", "Google Chrome";v="130", "Not?A_Brand";v="99"',
        "sec-ch-ua-mobile": "?0",
        "sec-ch-ua-platform": '"Windows"',
        "sec-fetch-dest": "empty",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "same-origin",
        "x-requested-with": "XMLHttpRequest",
      },
      referrer: "https://keat.mx/products/programa-de-desparasitacion-lunar",
      referrerPolicy: "strict-origin-when-cross-origin",
      body: `------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="quantity"\r\n\r\n${cantidad}\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="form_type"\r\n\r\nproduct\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="utf8"\r\n\r\n✓\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="properties[Fecha de Inicio]"\r\n\r\n${fechaInicio}\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="properties[Turno de entrega]"\r\n\r\ndía anterior PM\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="id"\r\n\r\n47749323161905\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="product-id"\r\n\r\n9177745031473\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="section-id"\r\n\r\ntemplate--23533971210545__main\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="sections"\r\n\r\ncart-notification-product,cart-notification-button,cart-icon-bubble\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn\r\nContent-Disposition: form-data; name="sections_url"\r\n\r\n/products/programa-de-desparasitacion-lunar\r\n------WebKitFormBoundarylOLRDXJDqKLhR1Bn--\r\n`,
      method: "POST",
      mode: "cors",
      credentials: "include",
    })
      .then((r) => r.json())
      .then((res) => {
        let c = new CartNotification();
        c.renderContents(res);
        el.removeClass("loading").removeClass("disabled");
        el.find(".loading-overlay__spinner").addClass("hidden");
      });

    return false;
  }
);

$(document).on(
  "click",
  ".cart-notification__links [type='button']",
  function (e) {
    e.preventDefault();
    document.location = "https://keat.mx/collections/all";
    return false;
  }
); 


